<template>
  <div class="pixelated" style="border: 1px solid #ddd; border-top: none; position: relative; width: 361px; height: 361px; overflow: hidden; flex-basis: 361px; flex-shrink: 0" :style="state === STATE_CRATE_LANDING && ! hasConfirmedDrop ? 'cursor: pointer' : null" @click="openCrate">
    <template v-if="state === STATE_CRATE_LANDING">
      <div class="ap-fill" :style="avatarBackgroundStyle" />
      <div class="ap-fill flat-crate" v-if="showItem" />

      <open-result-showcase v-if="showItem" :drops="newDrops" />

    </template>
    <template v-else>
      <div id="clouds1" class="ap-fill" />
      <div id="clouds2" class="ap-fill" />
      <div class="drop-countdown text-center">
        <div class="drop-countdown-header">NEXT RESUPPLY IN</div>
        <div class="drop-countdown-time">{{ timeToDrop }}</div>
      </div>
    </template>
    <canvas width="361" height="361" ref="dropCanvas" class="ap-tl" />
  </div>
</template>

<script>
import alert from 'alert';
import memberUtils from 'utils/member';
import { convertToCdnUrl } from 'utils';

const STATE_COUNTDOWN = 0;
const STATE_DROPPING = 1;
const STATE_CRATE_LANDING = 2;
const STATE_CRATE = 3;

import openResultShowcase from './open-result-showcase.vue';

export default {
	components: {
		openResultShowcase,
	},
	data () {
		return {
			STATE_COUNTDOWN,
			STATE_DROPPING,
			STATE_CRATE_LANDING,
			STATE_CRATE,

			requestedDrop: false,

			timerInterval: null,
			renderInterval: null,
			timeToDrop: '',
			state: STATE_COUNTDOWN, // animationsstate
			showItem: false,

			sprites: {
				box: {
					img: null,
					frame: 0,
				},
				plane: {
					img: null,
					frame: 0,
				},
			},
			isOnCrateScreen: true,
			hasConfirmedDrop: false,

			newDrops: [],
			hasAddedDropToInventory: false,
		};
	},
	props: ['nextDropTime', 'user', 'drops'],
	mounted () {
		this.timerInterval = setInterval(this.updateTimer.bind(this), 1000);

		const urlBase = '/img/member/supply-drop/';

		let img = new Image();
		img.src = convertToCdnUrl(urlBase + 'Box_spritesheet.png');
		this.sprites.box.img = img;

		img = new Image();
		img.src = convertToCdnUrl(urlBase + 'flyg3.png');
		this.sprites.plane.img = img;

		img = new Image();
		img.src = convertToCdnUrl(urlBase + 'BOX_flat.png');

		this.renderInterval = setInterval(this.renderDropCanvas.bind(this), 33);
	},
	beforeDestroy () {
		clearInterval(this.timerInterval);
		if (this.renderInterval) {
			clearInterval(this.renderInterval);
		}
	},
	computed: {
		avatarBackgroundStyle () {
			const backgroundImage = memberUtils.getBackgroundUrl(this.user);
			return {
				width: '100%',
				height: '100%',
				cursor: this.state === STATE_CRATE_LANDING ? 'pointer' : null,
				backgroundSize: 'cover',
				backgroundImage,
			};
		},
	},
	methods: {
		convertToCdnUrl,
		openCrate () {
			if (this.requestedDrop || this.sprites.box.frame < 5) {
				return;
			}
			this.requestedDrop = true;
			waja.post('supply-drop')
				.on('success', res => {
					this.$emit('open');
					this.hasConfirmedDrop = true;
					this.newDrops = res.data.drops;
				})
				.on('error', res => {
					// this.requestedDrop = false;
					if (res.status === 403) {
						alert('Du har redan plockat upp veckans supply drop!');
					} else {
						alert('Något gick fel :(');
					}
				}).go();
		},
		renderDropCanvas () {
			const canvas = this.$refs.dropCanvas;
			if (! canvas) {
				console.error('no canvas ref!! :(');
				return;
			}
			const ctx = canvas.getContext('2d');
			ctx.clearRect(0, 0, canvas.width, canvas.height);

			const pWidth = 400;
			const pHeight = 165;

			const cWidth = 400;
			const cHeight = 400;

			if (this.state === STATE_COUNTDOWN) {
				// update plane
				const spr = this.sprites.plane;
				spr.frame += 0.33;
				if (spr.frame >= 16) {
					spr.frame = 0;
				}
				const f = Math.floor(spr.frame);
				ctx.drawImage(spr.img, (f % 4) * pWidth, Math.floor(f / 4) * pHeight, pWidth, pHeight, -16, 128, pWidth, pHeight);
			} else if (this.state === STATE_DROPPING) {
				// update plane
				const spr = this.sprites.plane;
				spr.frame += 0.33;
				if (spr.frame < 16) {
					spr.frame = 16;
				} else if (spr.frame >= 34) {
					this.state = STATE_CRATE_LANDING;
				}
				const f = Math.floor(spr.frame);
				ctx.drawImage(spr.img, (f % 4) * pWidth, Math.floor(f / 4) * pHeight, pWidth, pHeight, -16, 128, pWidth, pHeight);
			} else if (this.state === STATE_CRATE_LANDING) {
				// update plane
				const spr = this.sprites.box;
				spr.frame += 0.25;
				if (spr.frame >= 5 && ! this.hasConfirmedDrop) {
					spr.frame = 5;
				} else if (spr.frame >= 13) {
					this.showItem = true;
				} else if (spr.frame >= 17) {
					if (this.renderInterval) {
						clearInterval(this.renderInterval);
						this.renderInterval = null;
					}
				}
				const f = Math.floor(spr.frame);
				ctx.drawImage(spr.img, (f % 5) * cWidth, Math.floor(f / 5) * cHeight, cWidth, cHeight, -16, 0, cWidth, cHeight);
			}
		},
		updateTimer () {
			const distance = (this.nextDropTime * 1000) - Date.now();
			if (distance <= 500) {
				if (this.state === STATE_COUNTDOWN) {
					this.state = STATE_DROPPING;
				}
				this.timeToDrop = '';
				return;
			}

			const days = Math.floor(distance / (1000 * 60 * 60 * 24));
			const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			const seconds = Math.floor((distance % (1000 * 60)) / 1000);

			let ttd = '';
			if (days) {
				ttd += days + ' DAYS ';
			}
			if (hours) {
				ttd += hours + 'H ';
			}
			if (minutes) {
				ttd += minutes + 'MIN ';
			}
			ttd += seconds + 's';
			this.timeToDrop = ttd;
		},
	},
};
</script>
